<!-- LOADING AREA START ===== -->
<div appLoader class="loading-area">
    <div class="loading-box"></div>
    <div class="loading-pic">
        <div class="cssload-spinner"></div>
    </div>
</div>
<!-- LOADING AREA  END ====== -->